
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalConeDown as ObiBuoyConicalConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-cone-down.js';
 
 
 

 
 export const ObiBuoyConicalConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-cone-down',
   elementClass: ObiBuoyConicalConeDownElement,
   events: {
     
   }
  });
 
 